const firebaseConfig = {
    apiKey: "AIzaSyCIUiMwq6pNVVH-UD_oy2grw9MDE5w1fkY",
    authDomain: "travel-website1.firebaseapp.com",
    projectId: "travel-website1",
    storageBucket: "travel-website1.appspot.com",
    messagingSenderId: "1058221068804",
    appId: "1:1058221068804:web:9191a6985f9f7beb61db51"
};
export default firebaseConfig;